import React, { Component } from 'react';
import './App.css';

import Main from './Main';
import RecentlyPlayed from './RecentlyPlayed';
import IcecastNowPlaying from './IcecastNowPlaying';

const default_album_art = 'https://albumart.customchannels.rocks/default-album-art.png';

class App extends Component {

  constructor(){
    super();

    this.state = {
      nowplaying: {
        title: "Title",
        artist: 'Artist',
        album: "Album",
        album_art: { large: default_album_art }},
      tracks: []
    };
  }

  setTrackData(data){
    let tracks = data.data.slice();
    let nowplaying = tracks[0];
    tracks.shift();

    this.setState({
      nowplaying: nowplaying,
      tracks: tracks
    });
  }

  componentWillMount(){
    // get the now playing
    const nowplaying = new IcecastNowPlaying(4102, 'http://stream.customchannels.net/hteao_web_128.mp3');
    nowplaying.checkIcecast((data) => {
      this.setTrackData(data);
    });

    setInterval(() => {
      nowplaying.checkIcecast((data) => {
        this.setTrackData(data);
      })
    }, 15000);
  }

  render() {
    return (
      <div className="App">
        <div className="container">
          <Main track={ this.state.nowplaying } />
        </div>
          <div className="clearfix"></div>
          <RecentlyPlayed tracks={ this.state.tracks } />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js